export default "__VITE_ASSET__DM93HP2h__"